/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Tone_ConversationalInputs */

const en_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversational`)
};

const de_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächig`)
};

const fr_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversationnel`)
};

const es_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversacional`)
};

const it_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloquiale`)
};

const nl_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informeel`)
};

const pl_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konwersacyjny`)
};

const fi_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keskusteleva`)
};

const da_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uformel`)
};

const sv_cover_letters_tone_conversational = /** @type {(inputs: Cover_Letters_Tone_ConversationalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konversation`)
};

/**
* | output |
* | --- |
* | "Conversational" |
*
* @param {Cover_Letters_Tone_ConversationalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_tone_conversational = /** @type {((inputs?: Cover_Letters_Tone_ConversationalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Tone_ConversationalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_tone_conversational(inputs)
	if (locale === "fr") return fr_cover_letters_tone_conversational(inputs)
	if (locale === "es") return es_cover_letters_tone_conversational(inputs)
	if (locale === "it") return it_cover_letters_tone_conversational(inputs)
	if (locale === "nl") return nl_cover_letters_tone_conversational(inputs)
	if (locale === "pl") return pl_cover_letters_tone_conversational(inputs)
	if (locale === "fi") return fi_cover_letters_tone_conversational(inputs)
	if (locale === "da") return da_cover_letters_tone_conversational(inputs)
	if (locale === "sv") return sv_cover_letters_tone_conversational(inputs)
	return en_cover_letters_tone_conversational(inputs)
});